import React from 'react';
import ReactDOM from 'react-dom/client';
import Chat from './components/chat/Chat';
import {StoreProvider} from 'easy-peasy';
import '@fortawesome/fontawesome-free/css/all.min.css';
import store from './services/store.service';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import LeadForm from './components/forms/Lead-form';
import Notification from './components/Notification';
import {ErrorBoundary} from 'react-error-boundary';
import Fallback from './components/Fallback';
import {logJsError} from './services/api.service';
import {ROUTES} from './models/routes.const';
import DataSetup from './components/DataSetup';
'use client';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const errorHandler = (error: Error) => {
    logJsError(error);
};

root.render(
        <React.StrictMode>
            <ErrorBoundary FallbackComponent={Fallback} onError={errorHandler}>
                <StoreProvider store={store}>
                    <Router>
                        <DataSetup />
                        <Routes>
                            <Route path={ROUTES.HOME} element={<></>} />
                            <Route path={ROUTES.CHAT} element={<Chat />} />
                            <Route path={ROUTES.LEAD_FORM} element={<LeadForm isEmbedded={false} />} />
                            <Route path={ROUTES.NOTIFICATION} element={<Notification />} />
                            <Route path={ROUTES.DEFAULT} element={<></>} /> {/* Default route */}
                        </Routes>
                    </Router>
                </StoreProvider>
            </ErrorBoundary>
        </React.StrictMode>
);
